import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    // Find modal and hidden input
    this.modalElement = document.getElementById("enquiryModal")
    this.propertyInput = document.getElementById("enquiry_property_id")
  }

  open(event) {
    event.preventDefault()

    // Set property_id in hidden input
    const propertyId = event.currentTarget.dataset.enquiryModalPropertyId
    this.propertyInput.value = propertyId

    // Show Bootstrap modal
    const modal = new bootstrap.Modal(this.modalElement)
    modal.show()
  }
}
